export default __webpack_public_path__ + "static/media/FondoGrisFinal.9c688ead.jpg";